import React, { useEffect, useState } from "react";
import { Cascader } from "antd";
import { useParams, useSearchParams, useLocation } from "react-router-dom";


const { SHOW_PARENT } = Cascader;

import store from "../../redux/store";
import * as Actions from "../../redux/actions";

const ModalContent = ({ setModalValue, modalValue }) => {
  const [treeData, setTreeData] = useState([]);


  let { marcaId, catalogoId, categoriaId } = useParams();

  useEffect(() => {
    store
      .dispatch(Actions.searchProducts({ key: "", catalogoId: catalogoId }))
      .then((data) => {
        const products = data.payload.data;

        const treeProducts = Object.keys(products).reduce((list, key, i) => {
          const parent = {
            label: products[key].nombre,
            value: key,
            key: key,
            children: [],
          };

          Object.keys(products[key].groups).map((secKey) => {
            const children = {
              label: products[key].groups[secKey].nombre,
              value: secKey,
              key: secKey,
              children: [],
            };

            Object.values(

                products[key].groups[secKey].products.reduce((eans, product, i) => {

                  eans[product.ean] = eans[product.ean] || {
                                                            label: product.titulo,
                                                            key: product.ean,
                                                            value: product.ean,
                                                            children: []
                                                          };
                
                  eans[product.ean].children.push({
                    label: product.code,
                    key: product.itf,
                    value: product.itf
                  })
                
                  return eans;

              }, {})

            ).map(ean => children.children.push(ean))

            parent.children.push(children);
          });

          list.push(parent);
          return list;
        }, []);

        setTreeData(treeProducts);
      });
  }, []);

  const onChange = (newValue) => {

    setModalValue(newValue);
  };


  const filter = (inputValue, path) =>
  path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);


  return (
    <div className="modal-content">
      <span className="title">
        Buscar y seleccionar productos para su nuevo catálogo.
      </span>

      <Cascader
        style={{ width: "100%" }}
        options={treeData}
        showCheckedStrategy={SHOW_PARENT}
        onChange={onChange}
        multiple
        maxTagCount="responsive"
        dropdownClassName={"cascader-dropdown"}
        showSearch={{
          filter,
        }}
      />
    </div>
  );
};

export default ModalContent;
